import {
  faExclamationTriangle,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Button } from 'semantic-ui-react'
import Accordion from '../../common/Accordion'
import GreyBox from '../../common/GreyBox'
import LoaderContext from '../../context/FormLoader'
import Conditional from '../../common/Conditional'
import { ICallout } from '../../../models/Callout'
import useCallout from '../../../hooks/useCallout'
import CalloutDisplay from '../../common/CalloutDisplay'

export const LetterOfResignationHeader = ({ show, setShow, handleStart }) => {
  const mountedRef = useRef(false)
  const [data, setData] = useState<ICallout[]>([])
  const [getCallout] = useCallout('LetterOfResignationTemplate', 'Before')
  const [isLoading, setIsLoading] = useState(true)
  const loader = useContext(LoaderContext)

  useEffect(() => {
    mountedRef.current = true
    loader.up()
    if (mountedRef.current) {
      getCallout()
        .then((response) => {
          if (mountedRef.current) {
            setData(response.callouts)
          }
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          setIsLoading(false)
          loader.down()
        })
    }
    return () => {
      mountedRef.current = false
    }
  }, [])
  return (
    <>
      <h1>Letter of resignation</h1>
      <Accordion
        heading="Welcome to our Template Tool"
        expanded={show}
        onClick={() => setShow()}
      >
        <p></p>
        <Conditional if={!isLoading}>
          {data &&
            data.map((c, i) => (
              <CalloutDisplay
                key={i}
                className=""
                content={c.content}
                name="LetterOfResignation"
              />
            ))}
        </Conditional>
        <p></p>
        <p>This tool will help you prepare a resignation letter.</p>
        <p>
          The tool will ask you simple questions and use your answers to tailor
          a letter for you. You will be able to save and edit your letter at the
          end.
        </p>
        <h2>Important information</h2>
        <p>
          Click the&nbsp;
          <FontAwesomeIcon
            className="ml-xs"
            icon={faExclamationTriangle}
            size={'1x'}
            color={'#da291c'}
          />
          &nbsp;buttons for important information about workplace rights and
          obligations
        </p>
        <h2>Get help</h2>
        <p>
          Click the&nbsp;
          <FontAwesomeIcon
            className="ml-xs"
            icon={faInfoCircle}
            size={'lg'}
            color={'#1b365d'}
          />
          &nbsp;buttons for explanations or help answering the question
        </p>
        <p>
          To protect your privacy none of the information you enter is stored in
          this tool or captured by the Office of the Fair Work Ombudsman.
        </p>

        <GreyBox>
          <p>
            <strong>Before you begin:</strong> To prepare your letter
            you&apos;ll need to know your employment start and end dates, as
            well as how much notice you need to provide.
          </p>
          <p>All fields are required unless marked optional.</p>
        </GreyBox>

        <Button className="ui is-primary button" onClick={handleStart}>
          Start
        </Button>
      </Accordion>
    </>
  )
}
